import React from 'react';
import { Tag, Tooltip } from 'antd';

import { FonteTagCellItem } from './useFontesTagsCell';

import { getFonteNumero, useFontesTagsCell } from './useFontesTagsCell';

interface IFontesTagsCellProps {
    fontes?: FonteTagCellItem[];
}

export const FontesTagsCell: React.FC<IFontesTagsCellProps> = ({ fontes }) => {
    const {
        containerRef,
        measureRef,
        tagsToRender,
        isOverflowing,
        todasAsFontes,
        hasFontes,
    } = useFontesTagsCell({ fontes });

    if (!hasFontes) {
        return null;
    }

    const content = (
        <div ref={containerRef} style={{ position: 'relative', width: '100%' }}>
            {/* Container invisível para medição de quebra de linha */}
            <div
                ref={measureRef}
                aria-hidden="true"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    visibility: 'hidden',
                    pointerEvents: 'none',
                    zIndex: -999,
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    rowGap: 4,
                }}
            >
                {fontes?.map((e) => (
                    <Tag key={e.id}>{getFonteNumero(e)}</Tag>
                ))}
            </div>

            {/* Container visível limitado a 3 linhas */}
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    rowGap: 4,
                    maxHeight: 76,
                    overflow: 'hidden',
                }}
            >
                {tagsToRender.map((e) => (
                    <Tag key={e.id}>{getFonteNumero(e)}</Tag>
                ))}
                {isOverflowing && (
                    <Tag key="dots" style={{ margin: 0, cursor: 'pointer' }}>...</Tag>
                )}
            </div>
        </div>
    );

    if (!isOverflowing) {
        return content;
    }

    return (
        <Tooltip
            title={todasAsFontes}
            placement="topLeft"
            overlayStyle={{ maxWidth: 350 }}
        >
            {content}
        </Tooltip>
    );
};

export default FontesTagsCell;
